import { useRouter } from 'next/router';
import React, { useCallback } from 'react';

import { Button, Icon, Space } from '@sravni/react-design-system';
import { Heading } from '@sravni/react-design-system/lib/Typography';
import { ArrowLeft } from '@sravni/react-icons';

export const NavigationHeader: React.FC = () => {
  const router = useRouter();

  const handleBackClick = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <Space direction={'horizontal'} size={8} align={'center'}>
      <Button onClick={handleBackClick} variant={'text'} color={'blue'} size={36}>
        <Icon size={20} icon={<ArrowLeft />} /> Назад
      </Button>
      <Heading level={3} as={'h1'}>
        Ваш отзыв
      </Heading>
    </Space>
  );
};
